import { Box, Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';
const ErrorMessage = ({ message }) => {
  return (
    <Box my={4}>
      <Alert status="error" borderRadius={4} justifyContent="center">
        <AlertIcon />
        <AlertDescription pt={1} maxWidth="xs">
          {message}
        </AlertDescription>
      </Alert>
    </Box>
  );
};

export default ErrorMessage;
